import { SelectSymbol } from 'components/form/compobox/select-symbol'

export default function Symbol({brand}) {
  return (
    <div className="space-y-2 border border-dashed p-2 rounded">
      <SelectSymbol washType="wash" brand={brand} />
      <SelectSymbol washType="bleach" brand={brand} />
      <SelectSymbol washType="tumble" brand={brand} />
      <SelectSymbol washType="iron" brand={brand} />
      <SelectSymbol washType="dry" brand={brand} />
    </div>
  )
}
